export const JIRA_BUTTON_SIZE = "70px";
export const ASSET_PAGE_HEADER_HEIGHT = 73;
